import ControllerTransitionOverlay from '../../components/Transition/ControllerTransitionOverlay';
import React from 'react';
import WellDoneRatLoader from '../../assets/loaders/WellDoneRatLoader.webp';
const ControllerVoteSummary = () => {
  return <ControllerTransitionOverlay image={WellDoneRatLoader} show={true} />;
};

export default ControllerVoteSummary;
